import { render, staticRenderFns } from "./PaypalFail.vue?vue&type=template&id=5762e6a0&scoped=true"
import script from "./PaypalFail.vue?vue&type=script&lang=js"
export * from "./PaypalFail.vue?vue&type=script&lang=js"
import style0 from "./PaypalFail.vue?vue&type=style&index=0&id=5762e6a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5762e6a0",
  null
  
)

export default component.exports